import { render, staticRenderFns } from "./shipmentrobot.vue?vue&type=template&id=6d03a19d&scoped=true"
import script from "./shipmentrobot.vue?vue&type=script&lang=js"
export * from "./shipmentrobot.vue?vue&type=script&lang=js"
import style0 from "./shipmentrobot.vue?vue&type=style&index=0&id=6d03a19d&prod&lang=scss&scoped=true"
import style1 from "./shipmentrobot.vue?vue&type=style&index=1&id=6d03a19d&prod&lang=scss"
import style2 from "./shipmentrobot.vue?vue&type=style&index=2&id=6d03a19d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d03a19d",
  null
  
)

export default component.exports